var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalWrapper',{staticClass:"c-modal-options l-modal-options",scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._t("header")]},proxy:true}],null,true)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }